import { BaseModel } from "model/BaseModel";

export default class HorarioItem implements BaseModel {

    id: number | null;
    codigo: string | null;
    diaSemana: number;
    horaInicio: number;
    horaFim: number;

    constructor(
        id = null,
        codigo = null,
        diaSemana = 0,
        horaInicio = 0,
        horaFim = 0,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.diaSemana = diaSemana;
        this.horaInicio = horaInicio;
        this.horaFim = horaFim;
    }
}
